/**
 * Contact form delivery settings.
 *
 * The form is sent through Web3Forms (https://web3forms.com), which forwards
 * every submission to the mailbox this access key was created for.
 * Replace the key here if the receiving mailbox ever changes.
 */
export const WEB3FORMS_ACCESS_KEY = '13451597-a00d-4422-8b5b-f5314d13c39b'
